import React from 'react';
import Search from './Search';
import PaypalInvoiceInfoTab from './paypalInvoiceInfo/PaypalInvoiceInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as Formatting from 'fw/misc/Formatting';
import { Link } from 'fw/components/formatter/Formatter';
import * as API from 'modules/app/API';
import * as Help from 'modules/app/Help';
import * as Notifications from 'fw/globals/Notifications';
import * as App from 'modules/app/App'

class PaypalInvoiceSetup extends React.Component {
    
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			loading: true,
			lastRunLabel: ""
		};
	}

	get = () => {
		API.Admin.get('/paypalInvoice/getJobLastExecuted', {},
			{
				success: (r) => {
					this.setState({
						loading: false,
						lastRunLabel: r.data
					});
				}
			});
	}

	componentDidMount() {
		this.get();
	}

	getRefreshLabel = () => {
		if (this.state.lastRunLabel)
			return (
				<em>
					&nbsp;&nbsp;&nbsp;Last Updated on: <b>{Formatting.formatClientDateTime(this.state.lastRunLabel)}</b>
				</em>
			);
		else
			return null;
    }

	executePayPalInvoices = (rq) => {
		const me = this;
        API.Job.post('/RetrievePaypalInvoices', {}, {
            success: (r) => {
                me.executePayPalInvoicesDetails(rq, r.message);
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

	executePayPalInvoicesDetails = (rq, message) => {
		const me = this;
        API.Job.post('/RetrievePaypalInvoicesDetails', {}, {
            success: (r) => {
				Notifications.success(r.message);
				Notifications.success(message);
				me.get();
				rq.search();
            },
            error: r => {
                Notifications.error(r.error.errorMessage);
            }
        });
    }

    render() {
		let opts = {
			title: "Paypal Invoices",
			setupKey: "paypalInvoiceSetup",
			enableColumnSettings: true,
			description: "",
			addPrivilege: false, // Template creation is no allowed for now
			addNewTitle: "",
			showTitle: false,
			enableExport: true,
			helpKey: Help.paypalInvoiceSetupHelpKey,
			recentType: "paypalInvoice",
			customAction: App.hasPrivilege("AdminPaypalExecuteRetrieveInvoices") ? { title: 'Refresh Table', onExecute: this.executePayPalInvoices } : null,
			customActionStyle: { glyphicon: 'refresh', bsStyle: 'success', label: this.getRefreshLabel() },
			sortField: "invoiceNumber",
			sortDirection: "DESC",
			list: {
                url: API.Admin.url('/paypalInvoice/search'),
				rowKey: "payPalInvoiceId",
				columns: [					
					{ key: 'invoiceNumber', name: 'Invoice #', sortable: true, width: 90 },
					{ key: 'invoiceDate', name: 'Invoice Date', sortable: true, formatter: Formatter.Date, width: 110 },
					{ key: 'invoiceDueDate', name: 'Due Date', sortable: true, formatter: Formatter.Date, width: 100 },
					{ key: 'invoiceTotalAmount', name: 'Amount', sortable: true, formatter: Formatter.Currency, width: 90 },
					{ key: 'invoiceStatus', name: 'Status', sortable: true },
					{ key: 'billingBusinessName', name: 'Business Name', width: 200, formatter: BusinessNameFormatter, getRowMetaData: (data) => (data), sortable: true },
					{ key: 'billingName', name: 'Bill To', width: 150, sortable: true },
					{ key: 'billingEmail', name: 'Email Address', sortable: true },
					{ key: 'imported', name: 'Imported', formatter: Formatter.Check, width: 80, cellClass: "text-center" },
					{ key: 'detailRetrievedDate', name: 'Retrieved', sortable: false, formatter: Formatter.ClientDateTime, width: 150 },
				]
			},
			tabs: [
				{ key: "invoiceInfo", title: "Invoice Info", comp: PaypalInvoiceInfoTab, helpKey: Help.paypalInvoiceSetupInfoHelpKey }
			]
		};

		opts = Object.assign(opts, this.props);

		return (
			<SetupPage {...opts}
				Search={Search} />
		);
	}
}

const BusinessNameFormatter = (row) => {
	if (!row.dependentValues.sponsorId)
		return <div>{row.dependentValues.billingBusinessName}</div>

    var url = `/admin/sponsorSetup/${row.dependentValues.sponsorId}/sponsorHistory`;
    var linkValue = {
        url: url,
        title: row.dependentValues.billingBusinessName
    };

    return <Link targetBlank={true} value={linkValue}></Link>
}

export default PaypalInvoiceSetup;


// WEBPACK FOOTER //
// ./src/areas/admin/paypalInvoiceSetup/PaypalInvoiceSetup.js